'use client';

import React from 'react';

interface SessionEntry {
  id: string;
  clockIn: string;
  clockOut: string | null;
  duration: string | null;
}

interface TodaySessionsSummaryProps {
  sessions: SessionEntry[];
}

export default function TodaySessionsSummary({ sessions }: TodaySessionsSummaryProps) {
  const totalMinutes = sessions.reduce((acc, s) => {
    if (s.duration && s.duration !== 'Calculating...') {
      const match = s.duration.match(/(\d+)h\s*(\d+)m/);
      if (match) {
        return acc + parseInt(match[1]) * 60 + parseInt(match[2]);
      }
    }
    return acc;
  }, 0);

  const totalDisplay = totalMinutes > 0
    ? `${Math.floor(totalMinutes / 60)}h ${totalMinutes % 60}m`
    : null;

  return (
    <div className="card-phone p-4">
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs font-semibold text-muted-foreground uppercase tracking-widest">
          Today&apos;s Sessions
        </p>
        {totalDisplay && (
          <span className="text-xs font-bold text-primary bg-secondary px-2 py-0.5 rounded-full">
            {totalDisplay} total
          </span>
        )}
      </div>

      <div className="flex flex-col gap-2">
        {sessions.map((session, idx) => (
          <div
            key={session.id}
            className="flex items-center gap-3 py-2.5 px-3 rounded-lg bg-secondary"
          >
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary flex items-center justify-center">
              <span className="text-white text-xs font-bold">{idx + 1}</span>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 text-sm font-semibold text-foreground tabular-nums">
                <span>{session.clockIn}</span>
                <span className="text-muted-foreground">→</span>
                <span className={session.clockOut ? 'text-foreground' : 'text-primary'}>
                  {session.clockOut ?? 'Active'}
                </span>
              </div>
              {session.duration && (
                <p className="text-xs text-muted-foreground mt-0.5">{session.duration}</p>
              )}
            </div>
            {!session.clockOut && (
              <div className="w-2 h-2 rounded-full bg-primary animate-pulse flex-shrink-0" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}